export default "__VITE_ASSET__86cad18a__"